export default __webpack_public_path__ + "static/media/seller_id_agency.1a968465.xlsx";